import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { loadConfig } from "@rtvloco/platform/env";
import { initAppTracing } from "./observability/tracing";
import { validateEnv } from "./config/envValidation";
import { themeManager } from "@rtvloco/theme/ThemeManager";
import "@rtvloco/ui/shell/styles";
import "./styles.css";
import "./styles/mobile.css"; // NEXT-642: additive <1024px layer — must load after styles.css
import "./i18n/i18n";


const AppLoadingSkeleton = () => (
  <div className="flow-loading-skeleton">Loading FLOW...</div>
);

async function bootstrap() {
  await loadConfig();
  themeManager.initialize();
  initAppTracing();
  const { default: App } = await import("./App");
  validateEnv();
  ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
    <React.StrictMode>
      <Suspense fallback={<AppLoadingSkeleton />}>
        <App />
      </Suspense>
    </React.StrictMode>
  );
}

bootstrap().catch((err) => {
  const root = document.getElementById("root");
  if (root) root.textContent = String(err);
});
